import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, BrowserBackGuard } from 'cbc-shared-lib';
import { Sgkz003dComponent } from './pages/sgkz003d/components/sgkz003d.component';
import { Sgkz004dComponent } from './pages/sgkz004d/components/sgkz004d.component';


const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canDeactivate: [BrowserBackGuard],
    children: [
      { path: 'sgkz003d', component: Sgkz003dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkz004d', component: Sgkz004dComponent, canDeactivate: [BrowserBackGuard] },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SgBaseSharedRoutingModule { 
  
}
